import {Router} from "./Router";

export const App = () => {
    return (
        <Router/>
    )
}
